var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxPlantingBotQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3267 3267",
    width: "256px",
    height: "256px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-0",
    width: 100,
    height: 100,
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "empty-0",
    d: "M0,28.6v42.9C0,87.3,12.8,100,28.6,100h42.9c15.9,0,28.6-12.8,28.6-28.6V28.6C100,12.7,87.2,0,71.4,0H28.6 C12.8,0,0,12.8,0,28.6z",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b-0",
    d: "M0,0 L66,0 C84.7776815,-3.44940413e-15 100,15.2223185 100,34 L100,66 C100,84.7776815 84.7776815,100 66,100 L0,100 L0,0 Z",
    transform: "rotate(-90 50 50)",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r-0",
    d: "M0,0 L66,0 C84.7776815,-3.44940413e-15 100,15.2223185 100,34 L100,66 C100,84.7776815 84.7776815,100 66,100 L0,100 L0,0 Z",
    transform: "rotate(-180 50 50)",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l-0",
    d: "M0,0 L66,0 C84.7776815,-3.44940413e-15 100,15.2223185 100,34 L100,66 C100,84.7776815 84.7776815,100 66,100 L0,100 L0,0 Z",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-0",
    d: "M0,0 L66,0 C84.7776815,-3.44940413e-15 100,15.2223185 100,34 L100,66 C100,84.7776815 84.7776815,100 66,100 L0,100 L0,0 Z",
    transform: "rotate(90 50 50)",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l-0",
    d: "M0,0 L100,0 L100,66 C100,84.7776815 84.7776815,100 66,100 L0,100 L0,0 Z",
    transform: "rotate(-90 50 50)",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lt-0",
    d: "M0,0 L100,0 L100,66 C100,84.7776815 84.7776815,100 66,100 L0,100 L0,0 Z",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lb-0",
    d: "M0,0 L100,0 L100,66 C100,84.7776815 84.7776815,100 66,100 L0,100 L0,0 Z",
    transform: "rotate(-90 50 50)",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rb-0",
    d: "M0,0 L100,0 L100,66 C100,84.7776815 84.7776815,100 66,100 L0,100 L0,0 Z",
    transform: "rotate(-180 50 50)",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rt-0",
    d: "M0,0 L100,0 L100,66 C100,84.7776815 84.7776815,100 66,100 L0,100 L0,0 Z",
    transform: "rotate(90 50 50)",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n_lt-0",
    d: "M30.5,2V0H0v30.5h2C2,14.7,14.8,2,30.5,2z",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n_lb-0",
    d: "M2,69.5H0V100h30.5v-2C14.7,98,2,85.2,2,69.5z",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n_rt-0",
    d: "M98,30.5h2V0H69.5v2C85.3,2,98,14.8,98,30.5z",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n_rb-0",
    d: "M69.5,98v2H100V69.5h-2C98,85.3,85.2,98,69.5,98z",
    fill: "#914cf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "point-0",
    fill: "#914cf8",
    d: "M600.001786,457.329333 L600.001786,242.658167 C600.001786,147.372368 587.039517,124.122784 581.464617,118.535383 C575.877216,112.960483 552.627632,99.9982143 457.329333,99.9982143 L242.670667,99.9982143 C147.372368,99.9982143 124.122784,112.960483 118.547883,118.535383 C112.972983,124.122784 99.9982143,147.372368 99.9982143,242.658167 L99.9982143,457.329333 C99.9982143,552.627632 112.972983,575.877216 118.547883,581.464617 C124.122784,587.027017 147.372368,600.001786 242.670667,600.001786 L457.329333,600.001786 C552.627632,600.001786 575.877216,587.027017 581.464617,581.464617 C587.039517,575.877216 600.001786,552.627632 600.001786,457.329333 Z M457.329333,0 C653.338333,0 700,46.6616668 700,242.658167 C700,438.667167 700,261.332833 700,457.329333 C700,653.338333 653.338333,700 457.329333,700 C261.332833,700 438.667167,700 242.670667,700 C46.6616668,700 0,653.338333 0,457.329333 C0,261.332833 0,352.118712 0,242.658167 C0,46.6616668 46.6616668,0 242.670667,0 C438.667167,0 261.332833,0 457.329333,0 Z M395.996667,200 C480.004166,200 500,220.008332 500,303.990835 C500,387.998334 500,312.001666 500,395.996667 C500,479.991668 480.004166,500 395.996667,500 C312.001666,500 387.998334,500 304.003333,500 C220.008332,500 200,479.991668 200,395.996667 C200,312.001666 200,350.906061 200,303.990835 C200,220.008332 220.008332,200 304.003333,200 C387.998334,200 312.001666,200 395.996667,200 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vk_logo-0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#07f",
    d: "M83.3334 363.333C83.3334 231.34 83.3334 165.343 124.338 124.338C165.343 83.3333 231.34              83.3333 363.333 83.3333H386.667C518.66 83.3333 584.657 83.3333 625.662 124.338C666.667 165.343              666.667 231.34 666.667 363.333V386.667C666.667 518.66 666.667 584.657 625.662 625.662C584.657              666.667 518.66 666.667 386.667 666.667H363.333C231.34 666.667 165.343 666.667 124.338 625.662C83.3334              584.657 83.3334 518.66 83.3334 386.667V363.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M394.907 508.681C263.293 508.681 183.442 417.365 180.313 265.625H246.972C249.05 377.09              299.763 424.323 338.638 434.036V265.625H402.519V361.82C440.016 357.664 479.264 313.909              492.456 265.625H555.333C545.27 325 502.543 368.754 472.353 386.803C502.566 401.395 551.177              439.593 569.926 508.681H500.815C486.222 462.498 450.476 426.728 402.542 421.872V508.681H394.907Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-mask-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 750,
    height: 750
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1455,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,97)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,194)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,291)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,291)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,291)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,291)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,291)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,291)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,291)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,291)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,388)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,388)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,388)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,388)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,388)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,388)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,388)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,388)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,388)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,485)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,485)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,485)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,485)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,485)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,485)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,485)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,485)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,485)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,582)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,582)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,582)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,582)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,582)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,582)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,582)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,582)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,582)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,679)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,679)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,679)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,679)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,679)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,679)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,679)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,679)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1455,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,776)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,873)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,970)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,1067)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,1164)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,1261)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,1358)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,1455)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,1552)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,1649)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,1746)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,1843)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,1940)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1455,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,2037)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(485,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1455,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,2134)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,2231)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(291,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,2328)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,2425)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,2522)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1455,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,2619)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1552,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,2716)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1164,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2716,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3104,2813)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(776,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1067,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n_rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2037,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2134,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2425,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,2910)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(970,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1261,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1455,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rb-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1746,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2619,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2910,3007)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(873,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1358,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1649,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1843,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1940,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2231,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rt-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2328,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2522,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2813,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3007,3104)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#empty-0"
  })), /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    transform: "translate(0,0)",
    xlinkHref: "#point-0"
  }), /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    transform: "translate(2496,0)",
    xlinkHref: "#point-0"
  }), /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    transform: "translate(0,2496)",
    xlinkHref: "#point-0"
  }), /*#__PURE__*/React.createElement("image", {
    preserveAspectRatio: "xMidYMid slice",
    clipPath: "url(#logo-mask-0)",
    width: 750,
    height: 750,
    transform: "translate(1238,1238) ",
    href: "./maxLogoQR.1444.png"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxPlantingBotQr);
export default __webpack_public_path__ + "static/media/MaxPlantingBotQr.46e8cd9073bef3b93c9df257c2cf8cd9.svg";
export { ForwardRef as ReactComponent };